<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="1" />
    <h4></h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                >search</i>
                Buscar
              </button>
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Descripción</th>
          <th scope="col">Respuesta</th>
          <th scope="col">Observación Descripción</th>
          <th scope="col">Respuesta Descripción</th>
          <th scope="col">Planilla Det Descripción</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pladetobs in datosPaginados" :key="pladetobs.idPlaDetObs">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(pladetobs.idPlaDetObs)"
              title="Editar"
            >edit_square</i>
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(pladetobs.idPlaDetObs)"
              title="Editar"
            >edit_square</i>
          </td>
          <td>{{ pladetobs.descripcion }}</td>
          <td>{{ pladetobs.respuesta }}</td>
          <td>{{ pladetobs.observacionDescripcion }}</td>
          <td>{{ pladetobs.respuestaDescripcion }}</td>
          <td>{{ pladetobs.planillaDetDescripcion }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deletePlaDetObs(pladetobs.idPlaDetObs)"
              title="Borrar"
            >delete</i>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" @click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          v-for="pagina in totalPaginas()"
          :key="pagina"
          @click="getDataPagina(pagina)"
          class="page-item"
          :class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" @click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      :aria-hidden="isModalOpen ? 'false' : 'true'"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="cerrarModal"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPlaDetObs" class="form-label">IdPlaDetObs</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idPlaDetObs"
                      name="idPlaDetObs"
                      v-model="datoPlaDetObs.idPlaDetObs"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPlanillaDet" class="form-label">Planilla Det</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-select"
                      id="idPlanillaDet"
                      name="idPlanillaDet"
                      v-model="datoPlaDetObs.idPlanillaDet"
                    >
                      <option
                        v-for="planillaDet in planillaDets"
                        :value="planillaDet.idPlanillaDet"
                        :key="planillaDet.idPlanillaDet"
                      >
                        {{ planillaDet.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-11">
                    <label for="filtroObservaciones" class="form-label">Filtrar Observaciones</label>
                    <input
                      type="text"
                      class="form-control"
                      id="filtroObservaciones"
                      v-model="filtroObservaciones"
                      placeholder="Buscar por nombre o tipo"
                      @input="filtrarObservaciones"
                    />
                  </div>
                  <div class="col-1">
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="limpiarFiltroObservaciones"
                      title="Limpiar filtro"
                    >
                      <i class="material-icons" style="font-size: 24px; color: gray; cursor: pointer">clear</i>
                    </button>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-2">
                    <label for="idObservacion" class="form-label">Observación</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idObservacion"
                      name="idObservacion"
                      v-model="datoPlaDetObs.idObservacion"
                    >
                      <option
                        v-for="observacion in observacionesFiltradas"
                        :value="observacion.idObservacion"
                        :key="observacion.idObservacion"
                      >
                        {{ observacion.nombre }} - ({{ getTipoTexto(observacion.tipo) }})
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idRespuesta" class="form-label">Respuesta</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idRespuesta"
                      name="idRespuesta"
                      v-model="datoPlaDetObs.idRespuesta"
                    >
                      <option
                        v-for="respuesta in respuestas"
                        :value="respuesta.idRespuesta"
                        :key="respuesta.idRespuesta"
                      >
                        {{ respuesta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="descripcion" class="form-label">Descripción</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoPlaDetObs.descripcion"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="respuesta" class="form-label">Respuesta</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="respuesta"
                      name="respuesta"
                      v-model="datoPlaDetObs.respuesta"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <div class="me-auto">
              <button
                type="button"
                id="send"
                class="btn btn-light"
                @click="cerrarModal"
                title="Cerrar"
              >
                <i
                  class="material-icons"
                  style="font-size: 32px; color: orangered; cursor: pointer"
                >meeting_room</i>
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarPlaDetObs"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
              >save</i> Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPlaDetObs"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
              >update</i> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import config from '@/config';
import Navbar from "../../components/Navbar.vue";
import Footer from "../../components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import * as bootstrap from 'bootstrap';
import swal from "sweetalert";

export default {
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      pladetobss: [],
      datoPlaDetObs: {},
      nombreBusqueda: "",
      filtroObservaciones: '', // Nueva propiedad para el filtro del select
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      planillaDets: [],
      observacions: [],
      respuestas: [],
      idEmpresa: 0,
      isModalOpen: false,
      modalInstance: null,
    };
  },
  computed: {
    observacionesFiltradas() {
      const texto = this.filtroObservaciones.toLowerCase().trim();
      if (!texto) {
        return this.observacions;
      }
      return this.observacions.filter(observacion =>
        (observacion.nombre?.toLowerCase() || '').includes(texto) ||
        this.getTipoTexto(observacion.tipo).toLowerCase().includes(texto)
      );
    },
  },
  mounted() {
    this.idEmpresa = window.sessionStorage.getItem("idEmpresa");
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.navbarRef.toggleProcesos();
    this.$refs.navbarRef.toggleReportes();
    this.$refs.navbarRef.toggleParametros();
    this.$refs.navbarRef.toggleAyuda();
    this.fetchPlanillaDets();
    this.fetchObservacions();
    this.fetchRespuestas();
    const modalElement = document.getElementById('ventanaModal');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
    }
  },
  methods: {
    getTipoTexto(tipo) {
      const tipos = {
        M: 'Auditoría Médica',
        D: 'Gestión Documental',
        C: 'Comunes',
      };
      return tipos[tipo] || tipo || 'Desconocido';
    },
    totalPaginas() {
      return Math.ceil(this.pladetobss.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda !== "") {
        api.get(`/vwpladetobss/nombre/${this.nombreBusqueda}`)
          .then((response) => {
            this.pladetobss = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.pladetobss.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwpladetobss")
        .then((response) => {
          this.pladetobss = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.pladetobss.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina === this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idPlanillaDet",
        "idObservacion",
        "idRespuesta",
        "descripcion",
        "respuesta",
      ];
      const requiredFieldsText = [
        "idPlanillaDet",
        "idObservacion",
        "idRespuesta",
        "descripcion",
        "respuesta",
      ];
      return validarForm(this.datoPlaDetObs, requiredFields, requiredFieldsText);
    },
    async guardarPlaDetObs() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/pladetobss", this.datoPlaDetObs);
          this.cerrarModal();
          swal("Correcto!", "PlaDetObs creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Inténtelo de nuevo!", "error");
          this.cerrarModal();
        }
      }
    },
    async actualizarPlaDetObs() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/pladetobss", this.datoPlaDetObs);
          this.cerrarModal();
          swal("Correcto!", "PlaDetObs actualizado(a) exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Inténtelo de nuevo!", "error");
          if (error.response?.data?.errors) {
            Object.values(error.response.data.errors).forEach((element) =>
              swal(String(element))
            );
          }
          this.cerrarModal();
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoPlaDetObs = {};
      this.filtroObservaciones = ''; // Limpiar filtro al crear
      this.titulo = "Crear";
      this.btnCrear = true;
      this.btnEditar = false;
      this.isModalOpen = true;
      if (this.modalInstance) {
        this.modalInstance.show();
      }
    },
    abrirModalEditar(idPlaDetObs) {
      this.modalWindow = true;
      this.filtroObservaciones = ''; // Limpiar filtro al editar
      if (idPlaDetObs != null) {
        api.get(`/vwpladetobss/${idPlaDetObs}`).then((resp) => {
          this.datoPlaDetObs = resp.data;
          this.titulo = "Editar";
          this.btnCrear = false;
          this.btnEditar = true;
          this.isModalOpen = true;
          if (this.modalInstance) {
            this.modalInstance.show();
          }
        });
      }
    },
    abrirEditar(idPlaDetObs) {
      if (idPlaDetObs != null) {
        this.$router.push(`/pladetobsmd/${idPlaDetObs}`);
      }
    },
    async deletePlaDetObs(idPlaDetObs) {
      try {
        await api.delete(`/pladetobss/${idPlaDetObs}`);
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        swal("Error!", "No se pudo eliminar", "error");
      }
    },
    fetchPlanillaDets() {
      fetch(config.apiBaseUrl + "/planilladets")
        .then((response) => response.json())
        .then((data) => {
          this.planillaDets = data;
        })
        .catch((error) => {
          console.error("Error fetching planillaDets:", error);
        });
    },
    fetchObservacions() {
      fetch(config.apiBaseUrl + "/vwobservacions")
        .then((response) => response.json())
        .then((data) => {
          this.observacions = data;
        })
        .catch((error) => {
          console.error("Error fetching observacions:", error);
        });
    },
    fetchRespuestas() {
      fetch(config.apiBaseUrl + `/vwobservacions/idempresa-tipo/${this.idEmpresa}/M`)
        .then((response) => response.json())
        .then((data) => {
          this.respuestas = data;
        })
        .catch((error) => {
          console.error("Error fetching respuestas:", error);
        });
    },
    cerrarModal() {
      this.isModalOpen = false;
      this.filtroObservaciones = ''; // Limpiar filtro al cerrar modal
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
    filtrarObservaciones() {
      // La lógica de filtrado está en la propiedad computada observacionesFiltradas
    },
    limpiarFiltroObservaciones() {
      this.filtroObservaciones = '';
    },
  },
};
</script>

<style src="@/assets/css/microfono.css" scoped></style>